import React from 'react';

export const UnsubscribeNextContext = React.createContext({
  page: 'unsubscribe',
  setPage: () => {},
});

export const useUnsubscribeNextContext = () => {
  return React.useContext(UnsubscribeNextContext);
};
